export default "__VITE_ASSET__1YBmQA1D__"